export const REGION_IDS = {
  JP: 2,
  GB: 3,
  DE: 4,
  SA: 7,
}
